export const EngCharUpperCase = (value) => {
  const engValue = value
    .toUpperCase() // Değeri büyük harflere çevir
    .replace(/[^A-Z0-9-\s]/g, ""); // A'dan Z'ye kadar olan harfleri, rakamları, '-' ve boşluk dışındaki tüm karakterleri kaldır
    
  return engValue;
};
